export type OpenWindowOptions = {
  target?: string;
  size?: typeof defaultSize;
  requiredOpener?: boolean;
};

export function openWindow(
  url: string,
  { target, size = defaultSize, requiredOpener = false }: OpenWindowOptions = {}
) {
  const features =
    target !== '_blank' && target !== '_self' ? makeFeatures(size) : undefined;

  const newWindow = window.open(url, target, features);

  if (newWindow) {
    try {
      const sameOrigin =
        newWindow.opener.location.origin === window.location.origin;

      if (requiredOpener) {
        newWindow.opener = sameOrigin ? window : null;
      }
    } catch (error) {
      console.error(error);
    } finally {
      newWindow.focus();
    }
  }

  return newWindow;
}

const makeFeatures = ({ width, height } = defaultSize) => {
  const { availWidth, availHeight } = window.screen;
  const { left, top } = {
    left: window.screenLeft + availWidth / 2 - width / 2,
    top: window.screenTop + availHeight / 2 - height / 2
  };

  const features = {
    ...defaultFeatures,
    width,
    height,
    top,
    left
  };

  return Object.entries(features)
    .map(([key, value]) => `${key}=${value}`)
    .toString();
};

const defaultSize = {
  width: 600,
  height: 600
};

const defaultFeatures = {
  menubar: 'no',
  toolbar: 'no',
  resizable: 'no',
  scrollbars: 'yes'
};
